// extracted by mini-css-extract-plugin
export default {"productDescription":"h--z","featuredDescription":"i--z","description":"j--z","more":"k--z","descriptionSku":"l--z"};